import { render, staticRenderFns } from "./DuelsGamesElement.vue?vue&type=template&id=004b094c&scoped=true"
import script from "./DuelsGamesElement.vue?vue&type=script&lang=js"
export * from "./DuelsGamesElement.vue?vue&type=script&lang=js"
import style0 from "./DuelsGamesElement.vue?vue&type=style&index=0&id=004b094c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004b094c",
  null
  
)

export default component.exports